


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import router from '@/router'
import { AnnouncementAdminService as _announcementAdminService } from '@/admin/services/announcementAdmin.service'
import { AnnouncementDto } from '@/models/dtos/AnnouncementDto'
import { SelectDto } from '@/models/dtos/selectDto'
import { ValidationObserver } from 'vee-validate'

@Component
export default class AdminAnnouncementCreateOrUpdate extends Vue {
  // Ref
  $refs!: {
    announcementForm: InstanceType<typeof ValidationObserver>;
  }

  // Data
  private announcementId: string | null = null
  private announcement: AnnouncementDto | null = null

  // Methods
  private async initAnnouncement() {
    this.announcementId = (this.$route.params as any)?.id || null

    this.announcement = {
      message: ''
    } as AnnouncementDto

    if (this.announcementId) {
      this.announcement = await _announcementAdminService.get(this.announcementId) || this.announcement
    }
  }

  private async saveOrUpdate(evt: any) {
    evt.preventDefault()

    if (!this.announcementId) {
      const announcementId = await _announcementAdminService.add(this.announcement!)
      router.push({ name: 'AdminAnnouncementEdit', params: { id: announcementId.toString() } })
    } else {
      _announcementAdminService.edit(this.announcement!)
    }
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.announcement
  }

  // Lifecycle
  async created() {
    this.initAnnouncement()
  }

  // Watchers
  @Watch('$route')
  async onRouteChange() {
    this.initAnnouncement()
    this.$refs.announcementForm.reset()
  }
}
